import { useEffect } from 'react';

/**
 * 저장 안 한 편집을 안고 탭을 닫으려 하면 브라우저에게 되물어 달라고 한다.
 *
 * 🔴 없으면 **편집이 통째로 조용히 사라진다.** 에디터는 자동 저장이 없고(저장은
 * 「저장」·「내보내기」를 누를 때만 일어난다) 편집 내용은 메모리에만 있다. 헤더에
 * `● 저장 안 됨` 을 띄우고는 있지만, 그건 «보고 있는 사람»에게만 닿는 신호다 —
 * 탭을 닫거나 새로고침하는 순간은 대개 그 배지를 안 보고 있는 순간이다.
 * (2026-09-11 점검: dirty 상태에서 `beforeunload` 가 아무도 안 막아 편집이 유실됐다.)
 *
 * 저장 요청이 날아가는 중(`saving`)도 막는다 — 여기서 닫으면 fetch 가 취소돼
 * 서버에는 안 들어가고 로컬 사본도 같이 사라진다. 「저장을 눌렀으니 됐겠지」가
 * 가장 위험한 순간이다.
 *
 * 문구는 지정하지 않는다. 최신 브라우저는 전부 자체 문구를 쓰고 커스텀 문자열을
 * 무시한다(Chrome 119+ 는 `returnValue` 도 안 읽는다) — `preventDefault()` 가
 * 유일하게 이식성 있는 신호다.
 */
export function useUnsavedGuard(enabled: boolean): void {
  useEffect(() => {
    if (!enabled) return;
    const onBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      // 옛 Safari/Firefox 는 아직 이 값이 있어야 확인창을 띄운다.
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, [enabled]);
}
